// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xxwu4GaExRJ4KgIOrACd {
    text-align: center;
    line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/pages/eligibility/components/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".splash {\n    text-align: center;\n    line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"splash": `Xxwu4GaExRJ4KgIOrACd`
};
export default ___CSS_LOADER_EXPORT___;
